// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountDetailsStyles from "@vanmeter/App/SharedStyles/MyAccountDetailsStyles";
import { orderApprovalDetailsActionButtonsStyles } from "@vanmeter/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import IconEdit from "@vanmeter/XDL/Icons/IconEdit";
import IconReorder from "@vanmeter/XDL/Icons/IconReorder";
import { createLinkIconStyles, modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

orderApprovalDetailsActionButtonsStyles.printLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.printLink,
};

orderApprovalDetailsActionButtonsStyles.deleteLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.removeAllLink,
};
orderApprovalDetailsActionButtonsStyles.approveLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.approveOrderLink,
};
orderApprovalDetailsActionButtonsStyles.editLink = {
    ...createLinkIconStyles({ icon: IconEdit, sizeVariant: "xsmall" }),
};
orderApprovalDetailsActionButtonsStyles.requestRevisionLink = {
    ...createLinkIconStyles({ icon: IconReorder, sizeVariant: "xsmall" }),
};

orderApprovalDetailsActionButtonsStyles.modalWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 15px;
    `,
};

orderApprovalDetailsActionButtonsStyles.actionsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

orderApprovalDetailsActionButtonsStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

orderApprovalDetailsActionButtonsStyles.submitButton = {
    ...modalButtonsActionStyles.submitButton,
};

orderApprovalDetailsActionButtonsStyles.modal = {
    sizeVariant: "small",
};

orderApprovalDetailsActionButtonsStyles.continueShoppingLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.backLink,
};
